import React, { useState } from "react";
import { ShowAlert } from "../../../common/alert";
import ViewSamplePopupCont from "../container/ViewSamplePopupCont";
import LoaderShade from "../../../shared/components/loaderShade/loaderShade";

const ViewSampleComp = ({ templatesContent, getTemplateID }) => {
   const [templateId, setTemplateId] = useState(null);
   const [ViewSample, setViewSample] = useState(false);
   const handleTemplate = (tempId, isSampleAvailable) => {
      if (isSampleAvailable) {
         setTemplateId(tempId);
         setViewSample(true);
      } else {
         ShowAlert("Sample is not available for this note!", "error");
      }
   };

   return (
      <>
         {templatesContent?.loading ? (
            <div className="w-100">
               <LoaderShade classname="epic-temp-loaders" />
               <LoaderShade classname="epic-temp-loaders" />
               <LoaderShade classname="epic-temp-loaders" />
            </div>
         ) : (
            <>
               {templatesContent?.list?.map((item) => {
                  const tempId = item?.id;
                  return (
                     <>
                        <div
                           onClick={() => {
                              getTemplateID(item.id);
                           }}
                           key={tempId}
                           className="epic-select-temp-box pointer"
                        >
                           <div>
                              <div className="epic-temp-title">{item.title || "Clinical note"} </div>
                              <p className="epic-truncate epic-discription-text">{item.shortDescription} </p>
                              <div
                                 className="view-sample-btn"
                                 onClick={() => handleTemplate(tempId, item?.isSampleAvailable)}
                              >
                                 <div className="epic-view-sample-text">View Sample</div>
                              </div>
                           </div>
                           {/* <div className="radio-item">
                              <input
                                 type="radio"
                                 onChange={() => {
                                    getTemplateID(item.id);
                                 }}
                                 value={item.id}
                                 name="radioGroup"
                                 className="cursor-pointer"
                              />
                           </div> */}
                        </div>
                     </>
                  );
               })}
            </>
         )}
         {ViewSample && <ViewSamplePopupCont templateId={templateId} onModalTapped={() => setViewSample(false)} />}
      </>
   );
};

export default ViewSampleComp;
